import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'dateDifference',
    standalone: false
})
export class DateDifferencePipe implements PipeTransform {
    transform(value: any, args: any[]): any {
        const startDate = moment(Number(value) - Number(args) < 1000 ? Number(args) - 1 : Number(args));
        const endDate = moment(value);

        const gapTime = moment(endDate, 'DD/MM/YYYY HH:mm:ss').diff(moment(startDate, 'DD/MM/YYYY HH:mm:ss'));
        const formattedDate = moment.duration(gapTime);
        const hours = formattedDate.hours() < 10 ? '0' + formattedDate.hours() : formattedDate.hours();
        const minutes = formattedDate.minutes() < 10 ? '0' + formattedDate.minutes() : formattedDate.minutes();
        const seconds = formattedDate.seconds() < 10 ? '0' + formattedDate.seconds() : formattedDate.seconds();

        return formattedDate.days() > 0
            ? `<b> ${hours}:${minutes}:${seconds}</b>&nbsp;<small><b>(+${formattedDate.months() > 0 ? Math.floor(formattedDate.asDays()) : formattedDate.days()}d)</b></small>`
            : `<b>${hours}:${minutes}:${seconds}</b>`;
    }
}
